<template>
  <div class="chartOne">
    <div ref="calendar" class="codMain"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    height: { type: [String, Number], default: "240" },
    width: { type: [String, Number], default: "480" },
    toolname: {
      type: [String, Number],
    },
    rowData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    unit: {
      type: [String, Number],
    },
  },
  watch: {
    "$store.state.open"(newVal, oldVal) {
      this.calendarChart.resize();
    },
    theme() {
      this.calendarChart.clear();
      if (this.theme == "westeros") {
        this.chartthem = "light";
      } else {
        this.chartthem = "dark";
      }
      this.drawChart();
    },
    rowData(newval) {
      this.calendarChart.clear();

      if (newval) {
        this.drawChart();
      }
    },
  },
  data() {
    return {
      calendarChart: null,
      option: null,
      rando_data: [],
      chartthem: "light",
    };
  },
  computed: {
    ...mapState(["theme"]),
  },
  mounted() {
    this.drawChart();
    window.addEventListener("resize", () => {
      this.calendarChart.resize();
    });
  },
  methods: {
    drawChart() {
      console.log(this.chartthem);
      this.calendarChart = this.$echarts.init(this.$refs.calendar, this.chartthem);
      this.option = this.initOption();
      this.calendarChart.setOption(this.option, true);
    },
    initOption() {
      console.log(this.rowData);
      console.log(this.unit);

      let toolname = this.toolname;
      console.log(toolname);
      let that = this;
      let option = {
        tooltip: {
          show: true,
          formatter: function (params) {
            return `${params.value[0]
              } <br/>${toolname}Average consumption: ${params.value[1].toFixed(2)}${that.unit}`;
          },
        },
        // backgroundColor: 'red',
        visualMap: [
          {
            show: false,
          },
        ],
        calendar: {
          itemStyle: {
            color: "rgba(128, 128, 128, 0.0)",
          },
          splitLine: {
            show: false,
          },
          left: "center",
          // top: 45,
          cellSize: "auto",
          yearLabel: { show: false },
          orient: "vertical",
          dayLabel: {
            firstDay: 1,
            nameMap: ["S", "M", "T", "W", "T", "F", "S"],
            fontSize: 16,
            color: "rgba(148, 148, 148, 1)",
          },
          monthLabel: {
            show: false,
          },
          range: this.rowData[0][0].slice(0, 7),
        },

        series: [
          {
            name: "",
            type: "effectScatter",
            coordinateSystem: "calendar",
            data: this.rowData,
            itemStyle: {
              color: "#000",
              // borderColor: "#42C1CC",
            },
          },
        ],
      };
      return option;
    },
  },
};
</script>

<style lang="scss" scoped>
.chartOne {
  width: 100%;
  // height: 100%;
  margin: 0 auto;
  // margin-right: 100px;

  ::-webkit-scrollbar {
    border-radius: 6px;
    width: 5px !important;
    background-color: #ccc;
  }

  ::-webkit-scrollbar-thumb {
    //滑块部分
    border-radius: 6px;
    background-color: #989898;
    height: 30px;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  .codMain {
    width: 96%;
    height: 300px;
    margin: 0 auto;
  }

  h4 {
    padding-top: 10px;
    padding-left: 36px;
    font-size: 16px;
    color: rgb(76, 76, 76);
  }
}
</style>
